// extracted by mini-css-extract-plugin
module.exports = {"image":"Navigator_image__36eSp"};